
// this file is automatically generated by version.ts script
export const versions = {
  revision: '56604eb8ab0a64142ac25fb3eb6c1abf3cfcca74',
  version: '1.119.0',
};
